/**
 * 🔌 BASE DATA CLIENT
 *
 * Base class for all data clients with common functionality.
 */
import { ConvexHttpClient } from "convex/browser";
/**
 * Create an authenticated Convex HTTP client
 *
 * @param config Client configuration
 * @returns Configured ConvexHttpClient
 */
export function createConvexClient(config = {}) {
    const convexUrl = config.convexUrl || process.env.NEXT_PUBLIC_CONVEX_URL || process.env.CONVEX_URL;
    if (!convexUrl) {
        throw new Error("CONVEX_URL environment variable is required");
    }
    const client = new ConvexHttpClient(convexUrl);
    if (config.sessionToken) {
        client.setAuth(config.sessionToken);
    }
    return client;
}
/**
 * Base data client with common functionality
 */
export class BaseDataClient {
    constructor(client) {
        this.client = client;
    }
    /**
     * Set authentication token for this client
     */
    setAuth(sessionToken) {
        this.client.setAuth(sessionToken);
    }
    /**
     * Clear authentication for this client
     */
    clearAuth() {
        this.client.clearAuth();
    }
}
